import React from "react";
import { Card, CardContent, Typography, Box, Input } from "@mui/joy";
import { Landmark } from "lucide-react";
import { SettingField } from "./EstimatingCommon";

interface FinancialSettingsProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function FinancialSettings({ values, onChange }: FinancialSettingsProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<Landmark size={18} />}>
                    Tax, Overhead & Fees
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    <SettingField label="Sales tax rate" description="Applied to material totals (Excel ~7.5%)">
                        <Input
                            size="sm"
                            endDecorator="%"
                            type="number"
                            value={values.EST_SALES_TAX_RATE}
                            onChange={(e) => onChange("EST_SALES_TAX_RATE", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="General insurance / overhead" description="Added to contract price (Excel 3.25%)">
                        <Input
                            size="sm"
                            endDecorator="%"
                            type="number"
                            value={values.EST_OVERHEAD_PERCENT}
                            onChange={(e) => onChange("EST_OVERHEAD_PERCENT", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Referral fee">
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            value={values.EST_REFERRAL_FEE}
                            onChange={(e) => onChange("EST_REFERRAL_FEE", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Permit tax">
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            value={values.EST_PERMIT_TAX}
                            onChange={(e) => onChange("EST_PERMIT_TAX", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Salesman commission %" description="Reference for margin planning">
                        <Input
                            size="sm"
                            endDecorator="%"
                            type="number"
                            value={values.EST_SALESMAN_COMMISSION_PERCENT}
                            onChange={(e) => onChange("EST_SALESMAN_COMMISSION_PERCENT", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>
                </Box>
            </CardContent>
        </Card>
    );
}
